module.exports = __webpack_public_path__ + "img/logo.9a930228.png";